import {
  successColor,
  whiteColor,
  grayColor,
  hexToRgb,
  primaryColor,
} from "../base";

const dashboardStyle = {
  successText: {
    color: successColor[0],
  },
  upArrowCardCategory: {
    width: "16px",
    height: "16px",
  },
  stats: {
    color: grayColor[0],
    display: "inline-flex",
    fontSize: "12px",
    lineHeight: "22px",
    "& svg": {
      top: "4px",
      width: "16px",
      height: "16px",
      position: "relative",
      marginRight: "3px",
      marginLeft: "3px",
    },
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      top: "4px",
      fontSize: "16px",
      position: "relative",
      marginRight: "3px",
      marginLeft: "3px",
    },
  },
  cardCategory: {
    color: grayColor[0],
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    paddingTop: "10px",
    marginBottom: "0",
  },
  cardCategoryWhite: {
    color: "rgba(" + hexToRgb(whiteColor) + ",.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitle: {
    color: grayColor[2],
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: grayColor[1],
      fontWeight: "400",
      lineHeight: "1",
    },
  },
  cardTitleWhite: {
    color: whiteColor,
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: grayColor[1],
      fontWeight: "400",
      lineHeight: "1",
    },
  },
  recordLink: {
    textDecoration: "none",
    color: primaryColor[0],
    fontSize: "1.2em",
  },
  skeleton: {
    width: "60%",
    margin: 5,
    float: "right",
    borderRadius: 3,
  },
  ".CardIcon-cardIcon-259.CardIcon-warningCardHeader-260, .CardIcon-cardIcon-259.CardIcon-successCardHeader-261, .CardIcon-cardIcon-259.CardIcon-dangerCardHeader-262, .CardIcon-cardIcon-259.CardIcon-infoCardHeader-263, .CardIcon-cardIcon-259.CardIcon-primaryCardHeader-264, .CardIcon-cardIcon-259.CardIcon-roseCardHeader-265":
    {
      backgroundColor: "#000",
    },
  "&$CardIcon-infoCardHeader-263": {
    // background: "linear-gradient(90deg, #3db7e4, #3db7e4)",
    background: "none",
    boxShadow: "none",
  },
};

export default dashboardStyle;
